import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import Button from "../Button/Button"
import { showSnackBar } from "../Snackbar/Snackbar"
import EmailSettingsFields from "./EmailSettingsFields"
import { orderGroupKeys } from "./emailGroups"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { USER_EMAIL_SETTINGS } from "../../config/featureFlagKeys"
import { getUserEmailSettings, saveUserEmailSettings } from "../../features/emailSettings/emailSettings"

const NOTHING_MUTED = { muteAll: false, mutedGroups: [] }

const EmailSettingsPanel = ({ userId }) => {
  const dispatch = useDispatch()
  const flagOn = useSelector(selectFeatureFlag(USER_EMAIL_SETTINGS))
  const [value, setValue] = useState(NOTHING_MUTED)
  const [loading, setLoading] = useState(true)
  const [loadFailed, setLoadFailed] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!flagOn || !userId) return undefined
    let active = true
    setValue(NOTHING_MUTED)
    setLoading(true)
    setLoadFailed(false)
    dispatch(getUserEmailSettings(userId)).then((result) => {
      if (!active) return
      if (result.error) {
        setLoadFailed(true)
      } else {
        setValue({
          muteAll: result.payload?.muteAll === true,
          mutedGroups: orderGroupKeys(result.payload?.mutedGroups),
        })
      }
      setLoading(false)
    })
    return () => {
      active = false
    }
  }, [flagOn, userId, dispatch])

  if (!flagOn || !userId) return null

  const handleSave = async () => {
    setSaving(true)
    const result = await dispatch(saveUserEmailSettings({ userId, muteAll: value.muteAll, mutedGroups: value.mutedGroups }))
    setSaving(false)
    if (result.error) {
      showSnackBar('error', result.payload || 'Could not save the email settings')
      return
    }
    showSnackBar('success', 'Email settings saved')
  }

  return (
    <div className="mt-8">
      <h3 className="text-lg font-semibold text-text-primary mb-1">Email notifications</h3>
      <p className="text-sm text-text-secondary mb-4">What this person gets by email about clients.</p>
      {loadFailed && <p className="text-sm text-text-secondary">Could not load the email settings.</p>}
      {!loadFailed && loading && <p className="text-sm text-text-secondary">Loading…</p>}
      {!loadFailed && !loading && (
        <>
          <EmailSettingsFields value={value} onChange={setValue} disabled={saving} />
          <div className="mt-6">
            <Button
              onClick={handleSave}
              size="lg"
              width="min-w-[156px]"
              disabled={saving}
              classes="rounded-lg"
            >
              Save notification settings
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

EmailSettingsPanel.propTypes = {
  userId: PropTypes.string,
}

export default EmailSettingsPanel
